<cevi-loading></cevi-loading>
<cevi-error-dialog></cevi-error-dialog>
<div class="c2-page cc theme-{{appService.theme}}" >

    <div class="c2-navbar-row theme-bg-color">
        <div class="c2-navbar-left" (click)="appService.setNextTheme()" >COBRA&#64;HOME</div>
        <nav class="c2-navbar-center">
            <a href="#" (click)="menuService.setActiveMenu(item)" [class.c2-navbar-active]="item==menuService.activeTextMenuItem" 
                *ngFor="let item of menuService.textMenuItems">
                {{item.title}}
            </a>
        </nav>
        <nav class="c2-navbar-right" >
        
            <div class="cobra-toggle">
                <ng-container *ngFor="let mode of menuService.documentModusItems" >
                <input tabindex="0" id="mode-{{mode.id}}"  [attr.aria-label]="mode.title" [value]="mode" name="documentmode" type="radio" [(ngModel)]="appService.currentDocumentMode"    />
                <label tabindex="-1" aria-hidden="true" for="mode-{{mode.id}}" [attr.title]="mode.title" [ngClass]="mode.cssclass" class="fa fa-2x c2-clickable"></label>
                </ng-container>
            </div>
            

            <a *ngFor="let item of menuService.iconMenuItems" (click)="navigateToIconMenuItem(item)"  title="{{item.title}}" href="#" 
                [attr.role]="item.role" 
                [attr.aria-checked]="item.selected" 
                [ngClass]="[item===menuService.activeIconMenuItem ? 'c2-navbar-active' : '',item.cssClass]" >
            </a>

            <form name="frmGlobalSearch" (submit)="zoek()" class="c2-inputgroup">
                <input title="Geef hier zoekterm in" type="text" name="zoekArg" [(ngModel)]="zoekArg.SearchFor" />
                <i role="button" title="Zoeken" tabindex="0" (keydown.enter)="zoek()" (click)="zoek()" class="icon-zoom"></i>
            </form>

            <a (click)="onRefresh()" href="#" title="Vernieuwen" role="button" class="icon-refresh btn-icon-dark"></a>
        </nav>
    </div>
 
    <div class="c2-contentaside-row"> 
        <div class="c2-content-col">
            <router-outlet></router-outlet>
            
            <div class="flyout-container-col" *ngIf="recenteNotitiesFlyout.isVisible">
                <div class="flyout-content" #recenteNotities [class.show]="recenteNotitiesFlyout.isActive">
                    <app-recente-notities class="c2-recente-notities"></app-recente-notities> 
                </div>
            </div>

            <div class="flyout-container-col" *ngIf="recenteBladwijzersFlyout.isVisible">
                <div class="flyout-content" #recenteBladwijzers [class.show]="recenteBladwijzersFlyout.isActive">
                    <app-recente-bladwijzers class="c2-recente-bladwijzers"></app-recente-bladwijzers>
                </div>
            </div>
            <app-document-viewer [documentdata]="menuService.currentdocument" *ngIf="menuService.documentViewerVisible"></app-document-viewer>

        </div>

        <div class="c2-pageaside-col">
            <a href="#" role="button" title="{{item.title}}" class="btn-icon" (click)="menuService.navigateToAsideMenuItem(item)"  [class.active]="item==menuService.activeAsideMenuItem" *ngFor="let item of menuService.asideMenuItems" class="asideMenuItem" [ngClass]="item.cssClass">
                <div *ngIf="item.badgeValue" [attr.aria-label]="item.badgeValue + ' nieuwe notitie'+(item.badgeValue>1 ? 's' : '')" class="badge theme-badge-color">{{item.badgeValue}}</div>
            </a>
        </div>
    </div>

</div>